import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import AdminLoginPage from './pages/AdminLoginPage';
import PosPage from './pages/PosPage';
import KdsPage from './pages/KdsPage';
import DesignGuidePage from './pages/DesignGuidePage';
import CustomerOnboardingPage from './pages/CustomerOnboardingPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminSubPlaceholder from './pages/admin/AdminSubPlaceholder';
import AdminProductsPage from './pages/admin/AdminProductsPage';
import AdminStaffPage from './pages/admin/AdminStaffPage';
import AdminSettingsPage from './pages/admin/AdminSettingsPage';
import AdminOrdersPage from './pages/admin/AdminOrdersPage';
import AdminDaysPage from './pages/admin/AdminDaysPage';
import AdminDayDetailPage from './pages/admin/AdminDayDetailPage';
import AdminCustomersPage from './pages/admin/AdminCustomersPage';
import AdminCustomerDetailPage from './pages/admin/AdminCustomerDetailPage';
import AdminStockPage from './pages/admin/AdminStockPage';
import AdminAuditPage from './pages/admin/AdminAuditPage';
import AdminAccountsPage from './pages/admin/AdminAccountsPage';
import AdminAccountDetailPage from './pages/admin/AdminAccountDetailPage';
import AdminLivePage from './pages/admin/AdminLivePage';
import AdminTablesPage from './pages/admin/AdminTablesPage';
import AdminBannersPage from './pages/admin/AdminBannersPage';
import PublicMenuPage from './pages/PublicMenuPage';
import RequireAuth from './components/RequireAuth';
import { RequireMinRoleRoute } from './components/RequireRole';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/design-guide" element={<DesignGuidePage />} />
      <Route path="/onboard-customer" element={<CustomerOnboardingPage />} />

      {/* Customer-facing menu — Phase 6.2 */}
      <Route path="/t/:code" element={<PublicMenuPage />} />

      {/* Till — anyone signed in (cashier+). */}
      <Route path="/pos" element={<RequireAuth><PosPage /></RequireAuth>} />

      {/* KDS — supervisor+. */}
      <Route
        path="/kds"
        element={
          <RequireMinRoleRoute role="SUPERVISOR">
            <KdsPage />
          </RequireMinRoleRoute>
        }
      />

      {/* Admin — manager+. Sub-routes share AdminLayout. */}
      <Route
        path="/admin"
        element={
          <RequireMinRoleRoute role="MANAGER">
            <AdminDashboardPage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/orders"
        element={
          <RequireMinRoleRoute role="MANAGER">
            <AdminOrdersPage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/products"
        element={
          <RequireMinRoleRoute role="MANAGER">
            <AdminProductsPage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/stock"
        element={
          <RequireMinRoleRoute role="MANAGER">
            <AdminStockPage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/customers"
        element={
          <RequireMinRoleRoute role="MANAGER">
            <AdminCustomersPage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/customers/:id"
        element={
          <RequireMinRoleRoute role="MANAGER">
            <AdminCustomerDetailPage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/accounts"
        element={
          <RequireMinRoleRoute role="MANAGER">
            <AdminAccountsPage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/accounts/:id"
        element={
          <RequireMinRoleRoute role="MANAGER">
            <AdminAccountDetailPage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/days"
        element={
          <RequireMinRoleRoute role="MANAGER">
            <AdminDaysPage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/days/:id"
        element={
          <RequireMinRoleRoute role="MANAGER">
            <AdminDayDetailPage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <RequireMinRoleRoute role="ADMIN">
            <AdminStaffPage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/settings"
        element={
          <RequireMinRoleRoute role="ADMIN">
            <AdminSettingsPage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/audit"
        element={
          <RequireMinRoleRoute role="ADMIN">
            <AdminAuditPage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/live"
        element={
          <RequireMinRoleRoute role="MANAGER">
            <AdminLivePage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/tables"
        element={
          <RequireMinRoleRoute role="MANAGER">
            <AdminTablesPage />
          </RequireMinRoleRoute>
        }
      />
      <Route
        path="/admin/banners"
        element={
          <RequireMinRoleRoute role="MANAGER">
            <AdminBannersPage />
          </RequireMinRoleRoute>
        }
      />
      {/* Catch-all under /admin so deep links don't 404 silently. */}
      <Route
        path="/admin/*"
        element={
          <RequireMinRoleRoute role="MANAGER">
            <AdminSubPlaceholder
              title="Not found"
              shipsIn="Admin"
              description="That admin section doesn't exist yet. Use the sidebar to navigate."
            />
          </RequireMinRoleRoute>
        }
      />

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
